export const cars = [
  {
    id: 1,
    brand: "Fiat",
    model: "Palio",
    year: 2015,
    image: "/palio/palio.webp",
    gallery: ["/palio/palio.webp", "/palio/palio1.webp"],
    features: [
      "1.4 Attractive",
      "5p",
      "Hatchback",
      "Nafta",
      "Aire Acondicionado",
      "Dirección Eléctrica",
      "5 puertas",
      "Económico",
    ],
    description:
      "El Fiat Palio 1.4 Attractive 5p es el hatchback compacto ideal para ciudad. Con su diseño práctico y bajo consumo, es perfecto para uso diario.",
    engine: "1.4L",
    transmission: "Manual",
    fuel: "Gasolina",
    itv: 2025,
    seats: 5,
    kilometers: 94200,
    price: 14500000,
    priceUSD: 15000,
    tanque: "48",
    featured: true,
  },
  {
    id: 2,
    brand: "Nissan",
    model: "March",
    year: 2014,
    image: "/march/march.webp",
    gallery: ["/march/march.webp", "/march/march1.webp", "/march/march2.webp"],
    features: [
      "1.6 Acenta L13",
      "Hatchback",
      "Gasolina",
      "Aire Acondicionado",
      "Dirección Eléctrica",
      "4 puertas",
      "Compacto",
      "Económico",
    ],
    description:
      "El Nissan March 1.6 Acenta L13 es el hatchback compacto perfecto para ciudad. Con su diseño moderno, bajo consumo y excelente rendimiento, es ideal para uso diario y estacionamiento fácil.",
    engine: "1.6L",
    transmission: "Manual",
    fuel: "Gasolina",
    itv: 2025,
    seats: 5,
    kilometers: 132600,
    price: 12494999,
    priceUSD: 12495,
    tanque: "41",
    featured: true,
  },
  {
    id: 3,
    brand: "Chevrolet",
    model: "Onix",
    year: 2015,
    image: "/onix/onix.webp",
    gallery: [
      "/onix/onix.webp",
      "/onix/onix1.webp",
      "/onix/onix2.webp"
    ],
    features: [
      "1.4 LT 5p L13",
      "Hatchback",
      "Gasolina",
      "Aire Acondicionado",
      "Dirección Eléctrica",
      "5 puertas",
      "Compacto",
      "Moderno",
    ],
    description:
      "El Chevrolet Onix 1.4 LT 5p L13 es el hatchback moderno y eficiente perfecto para ciudad. Con su diseño actual, bajo consumo y tecnología avanzada, es ideal para uso diario y estacionamiento fácil.",
    engine: "1.4L",
    transmission: "Manual",
    fuel: "Gasolina",
    itv: 2025,
    seats: 5,
    kilometers: 91800,
    price: 15402000,
    priceUSD: 15402,
    tanque: "47",
    featured: true,
  },
  {
    id: 4,
    brand: "Chevrolet",
    model: "Tracker",
    year: 2018,
    image: "/tracker1/trackergris.webp",
    gallery: [
      "/tracker1/trackergris.webp",
      "/tracker1/trackergris1.webp",
      "/tracker1/trackergris2.webp",
    ],
    features: [
      "1.8 4×2 LTZ L17",
      "SUV",
      "Gasolina",
      "Aire Acondicionado",
      "Dirección Asistida",
      "5 puertas",
      "4×4",
      "Espacioso",
    ],
    description:
      "El Chevrolet Tracker 1.8 4×2 LTZ L17 es el SUV perfecto para aventuras urbanas y rurales. Con su robustez, versatilidad y tecnología avanzada, te lleva a cualquier lugar con comodidad y estilo.",
    engine: "1.8L",
    transmission: "Manual",
    fuel: "Gasolina",
    itv: 2026,
    seats: 5,
    kilometers: 101300,
    price: 19838999,
    priceUSD: 19839,
    tanque: "53",
    featured: true,
  },
  {
    id: 5,
    brand: "Chevrolet",
    model: "Tracker",
    year: 2019,
    image: "/tracker2/trackerr.webp",
    gallery: [
      "/tracker2/trackerr.webp",
      "/tracker2/trackerr1.webp",
      "/tracker2/trackerr2.webp",
    ],
    features: [
      "1.8 4×2 LTZ L17",
      "SUV",
      "Gasolina",
      "Aire Acondicionado",
      "Dirección Asistida",
      "5 puertas",
      "4×4",
      "Espacioso",
    ],
    description:
      "El Chevrolet Tracker 1.8 4×2 LTZ L17 es el SUV perfecto para aventuras urbanas y rurales. Con su robustez, versatilidad y tecnología avanzada, te lleva a cualquier lugar con comodidad y estilo.",
    engine: "1.8L",
    transmission: "Manual",
    fuel: "Gasolina",
    itv: 2026,
    seats: 5,
    kilometers: 99300,
    price: 21828000,
    priceUSD: 21828,
    tanque: "53",
    featured: true,
  },
  {
    id: 6,
    brand: "Peugeot",
    model: "207",
    year: 2014,
    image: "/peu207/207.webp",
    gallery: ["/peu207/207.webp", "/peu207/2071.webp"],
    features: [
      "Compact 1.4 5P Xsallure",
      "Hatchback",
      "Gasolina",
      "Aire Acondicionado",
      "Dirección Eléctrica",
      "5 puertas",
      "Compacto",
      "Elegante",
    ],
    description:
      "El Peugeot 207 Compact 1.4 5P Xsallure es el hatchback elegante y eficiente perfecto para ciudad. Con su diseño francés, bajo consumo y tecnología avanzada, es ideal para uso diario y estacionamiento fácil.",
    engine: "1.4L",
    transmission: "Manual",
    fuel: "Gasolina",
    itv: 2025,
    seats: 5,
    kilometers: 103000,
    price: 13515000,
    priceUSD: 13515,
    tanque: "50",
    featured: true,
  },
  {
    id: 11,
    brand: "Peugeot",
    model: "208",
    year: 2016,
    image: "/peu208/peu208.webp",
    gallery: ["/peu208/peu208.webp", "/peu208/peu2081.webp", "/peu208/peu2082.webp"],
    features: [
      "1.5 Allure Touch 5p L13",
      "Hatchback",
      "Gasolina",
      "Aire Acondicionado",
      "Dirección Eléctrica",
      "5 puertas",
      "Compacto",
      "Tecnológico",
    ],
    description:
    "El Peugeot 208 1.5 Allure Touch 5p L13 es el hatchback tecnológico y elegante perfecto para ciudad. Con su diseño moderno, pantalla táctil y tecnología avanzada, es ideal para uso diario y estacionamiento fácil.",
    engine: "1.5L",
    transmission: "Manual",
    fuel: "Gasolina",
    itv: 2025,
    seats: 5,
    kilometers: 102800,
    price: 16575000,
    priceUSD: 16575,
    tanque: "50",
    featured: true,
  },
  {
    id: 12,
    brand: "Peugeot",
    model: "408",
    year: 2017,
    image: "/peu408/peu408.webp",
    gallery: ["/peu408/peu408.webp", "/peu408/peu4081.webp", "/peu408/peu4082.webp", "/peu408/peu4083.webp"],
    features: [
      "1.6 Allure L17",
      "Sedán",
      "Gasolina",
      "Aire Acondicionado",
      "Dirección Eléctrica",
      "4 puertas",
      "Espacioso",
      "Elegante",
    ],
    description:
    "El Peugeot 408 1.6 Allure L17 es el sedán elegante y espacioso perfecto para familias. Con su diseño sofisticado, confort superior y tecnología avanzada, ofrece una experiencia de conducción premium para viajes largos y uso diario.",
    engine: "1.6L",
    transmission: "Manual",
    fuel: "Gasolina",
    itv: 2025,
    seats: 5,
    kilometers: 123300,
    price: 15758999,
    priceUSD: 15759,
    tanque: "60",
    featured: true,
  },
  {
    id: 13,
    brand: "Chevrolet",
    model: "Agile",
    year: 2014,
    image: "/agile/agile.webp",
    gallery: ["/agile/agile.webp", "/agile/agile1.webp", "/agile/agile2.webp", "/agile/agile3.webp"],
    features: [
      "1.4 LT L13",
      "Hatchback",
      "Gasolina",
      "Aire Acondicionado",
      "Dirección Eléctrica",
      "5 puertas",
      "Compacto",
      "Económico",
    ],
    description:
    "El Chevrolet Agile 1.4 LT L13 es el hatchback compacto y económico perfecto para ciudad. Con su diseño práctico, bajo consumo y excelente maniobrabilidad, es ideal para uso diario y estacionamiento fácil.",
    engine: "1.4L",
    transmission: "Manual",
    fuel: "Gasolina",
    itv: 2025,
    seats: 5,
    kilometers: 101200,
    price: 13770000,
    priceUSD: 13770,
    tanque: "45",
    featured: true,
  },
  {
    id: 7,
    brand: "Chevrolet",
    model: "Tracker",
    year: 2018,
    image: "/tracker/tracker.webp",
    gallery: [
      "/tracker/tracker.webp",
      "/tracker/tracker1.webp",
      "/tracker/tracker2.webp",
    ],
    features: ["1.8 4×2", "LTZ Premier", "5 puertas", "Nafta", "SUV", "Aire Acondicionado", "Dirección Asistida"],
    description: "El Chevrolet Tracker 1.8 4×2 LTZ Premier es el SUV perfecto para aventuras urbanas y rurales. Con su robustez y versatilidad, te lleva a cualquier lugar con comodidad y estilo.",
    engine: "1.8L",
    transmission: "Manual",
    fuel: "Gasolina",
    itv: "2026",
    seats: 5,
    kilometers: 114800,
    price: 22338000,
    priceUSD: 22338,
    tanque: "53",
  },
  {
    id: 14,
    brand: "Renault",
    model: "Mégane",
    year: 2018,
    image: "/megane/principal.jpg",
    gallery: [
      "/megane/principal.jpg",
      "/megane/1.jpg",
      "/megane/2.jpg",
      "/megane/3.jpg",
      "/megane/4.jpg",
      "/megane/5.jpg",
      "/megane/6.jpg",
      "/megane/7.jpg",
      "/megane/8.jpg",
    ],
    features: [
      "1.6 Dynamique",
      "Aire Acondicionado",
      "Dirección Eléctrica",
      "5 puertas",
      "Radio Bluetooth",
      "Airbags",
      "ABS",
      "Control de Velocidad",
    ],
    description:
      "El Renault Mégane 1.6 Dynamique es el sedán perfecto para quienes buscan confort, estilo y tecnología. Con su diseño elegante y equipamiento completo, ofrece una experiencia de conducción superior.",
    engine: "1.6L",
    transmission: "Manual",
    fuel: "Gasolina",
    itv: "2025",
    seats: 5,
    kilometers: 183000,
    price: 5000000,
    priceUSD: 5000,
    tanque: "50",
    featured: true,
  },
  {
    id: 8,
    brand: "Renault",
    model: "Duster",
    year: 2018,
    image: "/Duster/m.webp",
    gallery: [
      "/Duster/principal.jpg",
      "/Duster/004ab2c4-77af-4ff6-98ef-47b9fa02f9a2.jpg",
      "/Duster/1246da8f-c88d-40f2-8ff8-5e1c979eacba.jpg",
      "/Duster/43c4f1d4-6a88-4b1f-8fd5-95added79811.jpg",
      "/Duster/53996875-210b-4934-8de5-8598ec3f1691.jpg",
      "/Duster/6aaa7511-8f28-474a-8fd6-86042aaf625a.jpg",
      "/Duster/8c7d1153-9b53-439e-aadf-ce9a9a89f593.jpg",
      "/Duster/a5f45ef1-1bdc-4929-a57e-237ad8ccbc50.jpg",
    ],
    features: [
      "4x4",
      "Espacio interior",
      "Seguridad 5 estrellas",
      "Conectividad avanzada",
    ],
    description:
      "El Renault Duster es el SUV perfecto para aventuras urbanas y rurales. Con su robustez y versatilidad, te lleva a cualquier lugar con comodidad y estilo.",
    engine: "1.6L 16 válvulas",
    transmission: "Manual",
    tanque: "20",
    fuel: "Gasolina",
    itv: "2026",
    seats: 5,
    kilometers: 123000,
    price: 25000000,
    priceUSD: 25000,
    sold: true,
  },
  {
    id: 9,
    brand: "Volkswagen",
    model: "Gol Power Plus",
    year: 2009,
    image: "/Gol/mmm.webp",
    gallery: [
      "/Gol/principal.jpg",
      "/Gol/1.jpg",
      "/Gol/05f7097a-b5bb-4b4b-9178-74e533b54998.jpg",
      "/Gol/376c0f61-63ae-4a94-99c6-adc4ddf3b621.jpg",
      "/Gol/3f657e71-de4f-4249-a5c7-e008fcdca6c3.jpg",
      "/Gol/644632af-cd66-40ab-9256-6753b509b849.jpg",
      "/Gol/6730e674-aab5-457e-a386-ff13a5a46e5a.jpg",
      "/Gol/684b8cad-f3f0-4b57-a5ba-1f8c6e2709c0.jpg",
      "/Gol/c330bc32-825c-4fc7-b368-765c3071b135.jpg",
      "/Gol/c8e6a064-5534-4570-982c-88d30deffe39.jpg",
      "/Gol/df656226-2967-4b95-bf4d-c8a2e1eda3e0.jpg",
      "/Gol/ee88c861-30f3-4a33-b8bf-e3b69e072111.jpg",
      "/Gol/effc4bdc-6dfc-438e-a5bf-71050e967327.jpg",
    ],
    features: [
      "Motor TSI",
      "Aire acondicionado",
      "Estéreo con USB / Bluetooth",
      "Cierre centralizado",
    ],
    description:
      "El Volkswagen Gol combina tradición y tecnología. Es el hatchback más confiable del mercado, ideal para uso diario con excelente rendimiento y bajo consumo.",
    engine: "1.6",
    transmission: "Manual",
    fuel: "Gasolina",
    tanque: "55",
    itv: "2026 Pago",
    seats: 5,
    kilometers: 210000,
    price: 7800000,
    priceUSD: 6000,
    sold: true,
  },
  {
    id: 10,
    brand: "Fiat",
    model: "Mobi",
    year: 2018,
    image: "/Mobi/principal.png",
    gallery: [
      "/Mobi/22a3d3e6-4525-484a-a131-f3ac647102ae.jpg",
      "/Mobi/151b03b5-cfa4-431e-b78f-f548ce8c5af3.jpg",
      "/Mobi/288f247e-bb02-4d33-a459-ca024e07e632.jpg",
      "/Mobi/3468b161-9270-4977-9ed5-ce514b51ed5f.jpg",
      "/Mobi/5608b43b-5872-4086-94e6-3e0ea32ad342.jpg",
      "/Mobi/5ea9fc6a-c018-499f-8402-8648f1ac2056.jpg",
      "/Mobi/6e25baff-fa83-470f-b7b9-14c5b255dc53.jpg",
      "/Mobi/70c408a1-5bb5-4024-92b8-e5ba33379265.jpg",
      "/Mobi/76a0cb8c-3e56-4a49-be6a-0e6b9cf9e10f.jpg",
      "/Mobi/820a480c-0fef-436c-9b2d-1b7d58feeb9f.jpg",
      "/Mobi/89ab0d88-8289-48e8-b274-df562e479da2.jpg",
      "/Mobi/99f45af4-473f-4951-86db-e5ff20c49b5c.jpg",
      "/Mobi/ad319431-58f9-49ee-adf0-d23c285948f5.jpg",
      "/Mobi/f04c9eaa-07cc-4103-b835-695ec291e2d3.jpg",
    ],
    features: [
      "Aire acondicionado",
      "Sistema de freno",
      "Dirección asistida",
      "Primera mano",
    ],
    description:
      "El Fiat Mobi es el city car más inteligente del mercado. Compacto, ágil y con excelente consumo, perfecto para moverte por la ciudad con facilidad.",
    engine: "1.0L 8v",
    transmission: "Manual",
    fuel: "Gasolina",
    itv: "2026 pago",
    seats: 5,
    kilometers: 108000,
    price: 12500000,
    priceUSD: 14000,
    tanque: "50",
    sold: true,
  },
  // {
  //   id: 8,
  //   brand: "Ford",
  //   model: "Fiesta",
  //   year: 2019,
  //   image: "/fiesta/fiesta1.webp",
  //   gallery: [
  //     "/fiesta/fiesta.webp",
  //     "/fiesta/fiesta1.webp",
  //     "/fiesta/fiesta2.webp",
  //   ],
  //   features: ["1.6 S Plus", "5 puertas", "Nafta", "Hatchback", "Aire Acondicionado", "Dirección Asistida"],
  //   description: "El Ford Fiesta 1.6 S Plus es el hatchback perfecto para la ciudad. Compacto, eficiente y con tecnología moderna, ideal para el día a día.",
  //   engine: "1.6L",
  //   transmission: "Manual",
  //   fuel: "Gasolina",
  //   itv: "2026",
  //   seats: 5,
  //   kilometers: 57200,
  //   price: 21675000,
  //   priceUSD: 21675,
  //   tanque: "47",
  // },
  
  // {
  //   id: 10,
  //   brand: "Citroën",
  //   model: "C3",
  //   year: 2016,
  //   image: "/citroenc3/citroenc3.webp",
  //   gallery: ["/citroenc3/citroenc3.webp", "/citroenc3/citroenc3.webp", "/citroenc3/c31.webp", "/citroenc3/c3.webp"],
  //   features: ["1.5 Tendance", "Pack Secure", "Hatchback", "Nafta", "Aire Acondicionado", "Dirección Eléctrica", "5 puertas"],
  //   description: "El Citroën C3 1.5 Tendance Pack Secure es el hatchback perfecto para la ciudad. Con su diseño moderno y equipamiento completo, ofrece comodidad y seguridad para tu día a día.",
  //   engine: "1.5L",
  //   transmission: "Manual",
  //   fuel: "Gasolina",
  //   itv: "2025",
  //   seats: 5,
  //   kilometers: 112500,
  //   price: 16319999,
  //   priceUSD: 16320,
  //   tanque: "45",
  //   featured: true
  // },
];
